import React, { Component } from 'react'


import './style.css'

class DigitalPage extends Component {
  render() {
    return (
      <div>

      </div>
    )
  }
}

export default DigitalPage;
